import Helmet from 'react-helmet';
import {
    SUITS_ME_APP_STORE,
    SUITS_ME_GOOGLE_PLAY_STORE,
} from 'lib/constants/routes';
import Typography from 'components/shared/generic/typography/presentational/Typography';
import SuitsMeLogo from '_content/images/logos/SuitsMe_Logo_Gradient.svg';
import AppStoreBadge from '_content/images/app-store/app-store-badge.png';
import GooglePlayBadge from '_content/images/app-store/google-play-badge.png';

const MaintenancePage = () => (
    <div className="login-container maintenance">
        <Helmet>
            <title>Maintenance | Suits Me Banking</title>
        </Helmet>
        <img src={SuitsMeLogo} alt="Suits Me" className="logo mt-4" />
        <Typography tag="h1" className="mt-4">
            Down for maintenance
        </Typography>
        <Typography tag="p" className="mt-2">
            This application is currently offline for maintenance. Please come
            back later.
        </Typography>
        <Typography tag="p" className="mt-2">
            In the meantime, you can still manage your account in the Suits Me
            app.
        </Typography>
        <div className="maintenance__badges">
            <a
                href={SUITS_ME_APP_STORE}
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src={AppStoreBadge} alt="Download on the App Store" />
            </a>
            <a
                href={SUITS_ME_GOOGLE_PLAY_STORE}
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src={GooglePlayBadge} alt="Get it on Google Play" />
            </a>
        </div>
    </div>
);

export default MaintenancePage;
